import styled from "@emotion/styled";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import { useState } from "react";
import colors from "theme/colors";
import { NewText, TitleWithLine, extractProperty } from "ui";
import VideoBoxCharge from "./VideoBoxCharge";

const StyledVideosCarouselWrapper = styled.div`
padding-top: 60px;
padding-bottom: 60px;
display: grid;
    gap: 54px;
  ${(props) => props.theme.breakpoints.up("md")} {
  padding-top: 10px;
    grid-template-columns: repeat(4, 1fr)
  }
`
const StyledWrapper = styled.div`
padding-top: 30px;
background: rgba(21, 62, 105, 0.1);

`
function VideoCarouselBlockCharge({ data }: { data: any }) {

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

    const blockTitle = extractProperty(data, "blockTitle")
    const subTitle = extractProperty(data, "subTitle")
    const stepsBlock: any[] = extractProperty(data, "stepsBlock")
    const handleVideoEnded = () => {
        setCurrentVideoIndex((currentVideoIndex + 1) % stepsBlock.length);
    };


    return (
        <StyledWrapper>
            <ContainerWrapper>
                <TitleWithLine
                    component={"h2"}
                    largeDesktopFontSize={48}
                    largeDesktopLineHeight="50px"
                    smallDesktopFontSize={48}
                    smallDesktopLineHeight="50px"
                    desktopLineHeight={"70px"}
                    mobileTitleFontSize={24}
                    mobileLineHeight={"28px"}
                    desktopFontWeight={500}
                    title={blockTitle}
                    titleColor={colors.black}
                />
                <NewText
                    component={"p"}
                    largeDesktopFontSize={18}
                    largeDesktopLineHeight="20px"
                    desktopFontSize={18}
                    desktopLineHeight={"20px"}
                    desktopFontWeight={400}
                    mobileFontSize={16}
                    mobileLineHeight={"18px"}
                    mobileFontWeight={400}
                    color={colors.black}
                    style={{ display: "block", paddingBottom: 10, paddingTop: 10 }}
                >
                    {subTitle}
                </NewText>
                {/* {isUserInteracted && */}
                <StyledVideosCarouselWrapper>
                    {stepsBlock.map((videoBlock: any, index: number) => {
                        const title = extractProperty(videoBlock, "stepTitle")
                        const text = extractProperty(videoBlock, "description")
                        const video = extractProperty(videoBlock, "video")
                        return (
                            <VideoBoxCharge
                                key={index}
                                index={index + 1}
                                title={title}
                                text={text}
                                isPlaying={currentVideoIndex === index}
                                onEndVideo={handleVideoEnded}
                                url={video}
                            />
                        )
                    }
                    )}
                </StyledVideosCarouselWrapper>
                {/* } */}
            </ContainerWrapper>
        </StyledWrapper>
    )
}
export default VideoCarouselBlockCharge
